import Axios from 'axios';
import Vue from 'vue';
import i18n from '../../i18n';
import { API_HOST } from '../../config/app-const';

const state = {
  editorOutlet: {
    isBusy: false,
    data: null,
    error: null
  }
};

const mutations = {
  LOAD_OUTLET_BUSY: (state, payload) => {
    state.editorOutlet.isBusy = payload;
  },
  LOAD_OUTLET_SUCCESS: (state, payload) => {
    state.editorOutlet.isBusy = false;
    state.editorOutlet.data = payload;
    state.editorOutlet.error = null;
  },
  LOAD_OUTLET_FAIL: (state, payload) => {
    state.editorOutlet.isBusy = false;
    state.editorOutlet.data = null;
    state.editorOutlet.error = payload;
  }
};

const actions = {
  addOutlet: ({ commit, rootState }, { projectId, outlet }) => {
    commit('LOAD_OUTLET_BUSY', true);

    const { accessToken } = rootState.user.user.data;
    const config = {
      headers: { Authorization: `Token token=${accessToken}` }
    };

    Axios
      .post(`${API_HOST}/analysis/editor/${projectId}/outlet`, outlet, config)
      .then(response => {
        commit('LOAD_OUTLET_SUCCESS', response.data)
      })
      .catch(error => {
        Vue.notify({
          group: 'store_notifications',
          type: 'error',
          text: i18n.t('messages.request.error')});

        console.error(error);
        commit('LOAD_OUTLET_FAIL', error)
      })
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};